import React from 'react';

const pageStyle = {
  maxWidth: '35rem',
  margin: '2rem auto auto',
  padding: '0 1.25rem',
  ' > *:not(:last-child)': {
    marginBottom: '1.25rem'
  }
};

function RegPage({ children }) {
  return <div css={pageStyle}>{children}</div>;
}

export default RegPage;
